/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2022 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { Link } from '@mui/material'

export const UserMismatchError = () => {
  return (
    <span>
      Невозможно подписать документ: ФИО в сертификате не совпадает с ФИО в{' '}
      <Link href="/my-account" rel="noopener noreferrer" target="_blank">
        личном кабинете
      </Link>
      .
      <br />
      Пожалуйста, измените ФИО в{' '}
      <Link href="/my-account" rel="noopener noreferrer" target="_blank">
        личном кабинете
      </Link>{' '}
      так, чтобы оно полностью соответствовало ФИО в вашем сертификате.
    </span>
  )
}
